import script from "./SidebarApp.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarApp.vue?vue&type=script&setup=true&lang=js"

import "./SidebarApp.vue?vue&type=style&index=0&id=0af3b916&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af3b916"]])

export default __exports__